<template>
  <div>
    <div class="noticeListMain">
      <div v-if="noticeList.length < 1">
        <img src="../../../assets/img/wu.png" style="width: 100%;height: 100%;">
        <span style="color: #999999;font-size: 16px;position: relative;left: 421px;top: -135px;">还没有发布任何消息</span>
      </div>
      <div style="flex: none;" v-else>
        <div class="notice-div" v-for="item in noticeList">
          <div class="notice-type">【{{item.typeName}}】</div>
          <div class="notice-content">{{item.notice}}</div>
          <div class="notice-day">发布时间：{{item.send_time}}</div>
        </div>
      </div>


<!--      <el-table-->
<!--        :data="noticeList"-->
<!--        :border="false"-->
<!--        style="width: 100%"-->
<!--        header-cell-class-name=""-->
<!--        :header-cell-style="setHeraderStyle"-->
<!--        v-loading="loading"-->
<!--        empty-text="No Data"-->
<!--      >-->
<!--        <el-table-column-->
<!--          v-for="(item, index) in columns"-->
<!--          :key="index"-->
<!--          :prop="item.prop"-->
<!--          :label="item.label"-->
<!--          :width="item.width"-->
<!--          show-overflow-tooltip-->
<!--        >-->
<!--        </el-table-column>-->
<!--      </el-table>-->


    </div>

    <table-page
      :pageSize="pageSize"
      :layout="layout"
      :pageTotal="pageTotal"
      :currentPage="currentPage"
      @pageChange="pageChange"
      v-if="noticeList.length > 0"
    ></table-page>
  </div>
</template>

<script>
import axios from "axios";
import { language } from "../../../language/get";
import tablePage from "../components/tablepage/tablepage";
import Cookie from "../../../common/cookie";
import { noticeList } from "@/api/newRequest";
import { getNoticeList } from "@/api/notice";
import { mapGetters } from "vuex";
const pubLanguage = language();
export default {
  name: "noticeList",
  components: {
    tablePage,
  },
  computed: {
    ...mapGetters(["token", "userInfo"])
  },
  data() {
    return {
      language: language(),
      lan: Cookie.get("lang"),
      noticeList: [],
      columns: [],
      loading: true,
      pageTotal: 0,
      pageSize: 10,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
    };
  },
  created() {},
  mounted() {
    this.getNoticeList();
  },
  methods: {
    getNoticeList() {
      //公告列表
      let params = {
        lan: this.lan,
        currentPage: this.currentPage,
        numberPage: this.pageSize,
        user_id: this.userInfo.user_id
      };
      getNoticeList(params).then((res) => {
        if (res.type == 1) {
          this.noticeList = res.data;
          if (this.lan=="en") {
             this.noticeList.forEach(item => {
              item.typeName = item.typeName=="公告"?"notice":"inform"
            });
          }
          this.pageTotal = Number(res.datacount);
          this.loading = false;
        }
      });
      // axios
      //   .get("http://192.168.1.203:8080/notice", {
      //     params: {
      //       lan: this.lan,
      //       currentPage: this.currentPage,
      //       numberPage: this.pageSize,
      //     },
      //   })
      //   .then((res) => {
      //     if (res.status == 200) {
      //       this.noticeList = res.data.data;
      //       this.pageTotal = res.data.count;
      //       this.loading = false;
      //     }
      //   });

      const columns = [
        {
          label: pubLanguage.noticeContent,
          prop: "notice",
          width: "580",
        },
        /*{
          label: pubLanguage.noticeExhName,
          prop: "exhName",
          width: "200",
        },*/
        {
          label: pubLanguage.noticeDate,
          prop: "send_time",
          width: "180",
        },
        {
          label: pubLanguage.noticeType,
          prop: "typeName",
          width: "auto",
        }
      ];
      this.columns = columns;
    },
    //设置表头样式
    setHeraderStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return `background-color: #F2F2F2;
                        color: #424242;
                        padding:7.5px 0;
                        font-size:14px;
                        font-weight: normal;
                        `;
      }
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.getNoticeList();
    },
  },
};
</script>

<style>
.noticeListMain {
  width: 999px;
  /*background: #fff;*/
  /*padding: 40px;*/
  display: flex;
  box-sizing: border-box;
}
.noticeListMain .el-table__header th {
  border-top: 1px solid #e6e6e6 !important;
  border-bottom: 1px solid #e6e6e6 !important;
  padding: 0;
}
.el-table th > .cell {
  border: none;
}
.page {
  text-align: center;
  margin-top: 32px;
  margin-left: 218px;
  /*display: flex;*/
}
.page .el-pagination .el-pagination__jump {
  font-size: 16px;
}
.page .el-pagination .btn-prev,
.page .el-pagination .btn-next{
  background: #FFFFFF;
  width: 58px;
  height: 28px;
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  color: #333333 !important;
  margin-right: 20px;
}
.page .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #0071ff;
}
/*.page .el-pagination.is-background {*/
/*  padding-left: 265px;*/
/*}*/
.page .el-pagination.is-background .el-pager li {
  margin-right: 20px;
}
.notice-div {
  width: 993px;
  /*height: 173px;*/
  background-color: #ffffff;
  border-radius: 5px;
  padding: 20px 30px 20px 20px;
  margin-bottom: 10px;
}
.notice-type {
  /*width: 114px;*/
  /*height: 24px;*/
  font-size: 24px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: 0px;
  color: #0071ff;
}
.notice-content {
  text-indent: 2em;
  margin-left: 12px;
  word-wrap: break-word;
  color: #666666;
  margin-top: 20px;
}
.notice-day {
  text-align: right;
  color: #666666;
  margin-top: 15px;
}
</style>
